module.exports = __webpack_public_path__ + "img/item_reunion_tip.dd0e2b70.png";